import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Trans, useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import { usePortal } from "../../../Providers/PortalProvider";
import {
  Popup,
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../components/Common/Popup";
import DialogContentText from "@material-ui/core/DialogContentText";

const NotReceivedCodeDialog = ({ onClose }) => {
  const { t } = useTranslation();
  const portal = usePortal();

  return (
    <Popup maxWidth={"xs"}>
      <PopupHeading>
        <Trans>Not received your code?</Trans>
      </PopupHeading>
      <PopupContent>
        <p>
          {t(
            "All students at schools that have been photographed by %s will receive an SMS, letter or an email after the photo shoot once the images are ready. They will contain with instructions on how to photos and order prints.",
            {
              postProcess: "sprintf",
              sprintf: [portal.name],
            }
          )}
        </p>
        <p>
          {t(
            "Have your friends received their pictures and you have not? Please contact us at %s with name of the photographed, group and location for the shoot. Remember to include your name and how to best contact you. We will then help you get access to your pictures!",
            {
              postProcess: "sprintf",
              sprintf: [portal.contactInfo.email],
            }
          )}
        </p>
      </PopupContent>
      <PopupActions>
        <PopupButton onClick={onClose}>
          <Trans>Ok</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default NotReceivedCodeDialog;
